import cn from "classnames";
import React from "react";

export interface TagListItemProps {
  item: { displayName: string; id: string; url: string | null };
  isSelected: boolean;
  onSelect: () => void;
  count: number;
}

export const TagListItem: React.FC<TagListItemProps> = ({
  item,
  isSelected,
  onSelect,
  count,
}) => (
  <div
    key={item.id}
    className={cn(
      "flex flex-row justify-between items-center px-2 py-1.5 gap-1 h-7 rounded-md cursor-pointer hover:bg-background-tertiary transition-all select-none",
      isSelected && "bg-background-tertiary text-text-primary"
    )}
    onClick={onSelect}
  >
    <div className="flex-1 text-xs text-secondary-n-50 truncate">
      {item.displayName}
    </div>
    <span className="text-xs text-text-tertiary pl-2">{count ?? 0}</span>
  </div>
);
